import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Alert } from "@material-ui/lab";
import { useIntl } from "react-intl";
import { messages } from "./ModifyParticipantsWarning.messages";
import { useStyles } from "./ModifyParticipantsWarning.style";

interface Props {
  showWarning: boolean;
}

const ModifyParticipantsWarning = (props: Props) => {
  const intl = useIntl();
  const { showWarning } = props;
  const classes = useStyles();

  if (!showWarning) {
    return null;
  }

  return (
    <div className={classes.container}>
      <Alert severity="warning">
        {intl.formatMessage(messages.alertWarningText)}
      </Alert>
    </div>
  );
};

export default ModifyParticipantsWarning;
